import NewUserIcon from "components/icons/NewUserIcon";
import EuroIcon from "components/icons/EuroIcon";
import GraphIcon from "components/icons/GraphIcon";
import BoxIcon from "components/icons/BoxIcon";
import IconAndInformation from "components/common/IconAndInformation";
import { useTranslation } from "react-i18next";
import s from "./styles";
import { useBusinessContext } from "../../../BusinessApp";

function TodayInformation(props) {
  const { currencyFormat } = useBusinessContext();
  const { t } = useTranslation();
  const date = new Date();
  const dateString = new Intl.DateTimeFormat("es", {
    dateStyle: "full",
    timeStyle: "long",
  })
    .format(date)
    .split(",")[1];

  return (
    <s.Container>
      <s.Title>
        {t("containers.Dashboard.TodayInformation.todayEarnings")}
        {dateString}
      </s.Title>
      <s.InformationContainer>
        <IconAndInformation
          icon={<GraphIcon />}
          top={props.sells || 0}
          bottom={t("containers.Dashboard.TodayInformation.sells")}
        />
        <IconAndInformation
          icon={<EuroIcon />}
          top={`${currencyFormat(props.earnings) || 0}`}
          bottom={t("containers.Dashboard.TodayInformation.earnings")}
        />
        <IconAndInformation
          icon={<NewUserIcon />}
          top={props.newClients || 0}
          bottom={t("containers.Dashboard.TodayInformation.newClients")}
        />
        <IconAndInformation
          icon={<BoxIcon />}
          top={props.mostSelling || "_"}
          bottom={t("containers.Dashboard.TodayInformation.mostSelling")}
        />
      </s.InformationContainer>
    </s.Container>
  );
}

export default TodayInformation;
